module.exports = __webpack_public_path__ + "media/images/wrong-new-7b67cf78b4f41b052019eeb1aeb398db.jpeg";